import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { axiosClient } from '@/utils/apiClient';

interface CreateSenderRequest {
  liveChatId: string;
  companyId: string;
}

interface CreateSenderResponse {
  id: string;
  channelIdentityId: string;
  companyId: string;
  sessionSignature: string;
}

export type useSenderCreateOption = UseMutationOptions<
  CreateSenderResponse,
  Error,
  CreateSenderRequest
>;

export const useSenderCreate = (options?: useSenderCreateOption) => {
  return useMutation({
    mutationFn: async (request: CreateSenderRequest) => {
      const response = await axiosClient.post<CreateSenderResponse>(
        '/LiveChatV2/Public/Senders',
        request,
      );

      return response.data;
    },
    ...options,
  });
};
